module.exports = __webpack_public_path__ + "static/img/20096B_2_3_R_20211027_fit.ccf5d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20096B_2_3_R_20211027_fit.png
// module id = fu7n
// module chunks = 0